module.exports = __webpack_public_path__ + "static/image/font/pc/bmeuljiro10yearslater-3@3x.ver2_0_2.jpg?fa26947e";